import classNames from 'classnames';
import { convertToUSDate } from 'utilities';
import styles from './Status.module.scss';
export interface StatusProps {
	className?: string;
	startDate: string;
	state: 'active' | 'pending';
	style?: 'default' | 'contrast';
}

export const Status: React.FC<StatusProps> = ({ className, startDate, state, style = 'default' }) => {
	//ToDo - Implement dictionary in Optimizely for global texts? - Hardcoded for now
	/*const dictionary = useContext(DictionaryContext);
	const handleStatusText = (): string => {
		if (state === 'pending') return _Status(dictionary, 'Pending');
		const todayDate = new Date();
		const activeDate = convertToUSDate(startDate);

		if (activeDate > todayDate) {
			return `${_Status(dictionary, 'ActiveFrom')} ${startDate}`;
		}
		return _Status(dictionary, 'Active');
	};*/
	const handleStatusText = (): string => {
		if (state === 'pending') return 'Afventer';
		const todayDate = new Date();
		const activeDate = convertToUSDate(startDate);

		if (activeDate > todayDate) {
			return `Aktiv fra ${startDate}`;
		}
		return 'Aktiv';
	};

	return (
		<div className={classNames(styles.Status, styles[`Status___${style}`], className)}>
			<div className={styles.Status_wrapper}>
				<span className={classNames(styles.Status_color, styles[`Status_color___${state}`])}></span>
				<p className={styles.Status_text}>{handleStatusText()}</p>
			</div>
		</div>
	);
};
